import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import UniversalDropDown from '../dropDown/unuversalDropDown'

import NextBtn from "./nextBtn";

import { AddressSuggestions, DaDataSuggestion, DaDataAddress } from "react-dadata";
import 'react-dadata/dist/react-dadata.css';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import {
    selectEmail,
    selectInsuranceCompanyLife,
    selectInsuranceCompanyProperty,
    setEmail,
    setStepCalc
} from './calcSlice';
import {
    selectAddresObject,
    selectFire,
    selectKlAdrHolderReg,
    selectKlAdrObj,
    selectLevel,
    selectMaterialBuild,
    selectNumLevels,
    selectNumRooms,
    selectSquare,
    selectYearBuild,
    setAddresObject,
    setFire,
    setKlAdrHolderReg,
    setKlAdrObj,
    setLevel, setMaterialBuild, setNumLevels, setNumRooms, setSquare, setYearBuild
} from "./objectSlice";
import { listFire, listMaterialBuild, listNumLevels, listNumRooms } from "../../static/vars";
import { InputMask } from "primereact/inputmask";
import { selectRegAdr } from './personSlice';


export function DataObject() {
    const [next, setNext] = useState(false)

    const [checkOne, setCheckOne] = useState(false)
    const [checkTwo, setCheckTwo] = useState(false)
    const [checkThree, setCheckThree] = useState(false)
    const [checkFour, setCheckFour] = useState(false)
    const [checkSameAddr, setCheckSameAddr] = useState(false);

    const [showAlertForUser, setShowAlertForUser] = useState(false);
    const [isEmptyAddress, setIsEmptyAddress] = useState(false);
    const [isEmptyNumLevels, setisEmptyNumLevels] = useState(false);
    const [isEmptyNumRooms, setisEmptyNumRooms] = useState(false);
    const [isEmptySquare, setisEmptySquare] = useState(false);
    const [isEmptyYearBuild, setIsEmptyYearBuild] = useState(false);

    const [isNumLevelManager, setIsNumLevelManager] = useState(false);
    const [showAllFields, setShowAllFields] = useState(false);
    const [whait, setWhait] = useState(false);

    const dispath = useDispatch()
    const addresObject = useSelector(selectAddresObject)

    const fire = useSelector(selectFire)
    const materialBuild = useSelector(selectMaterialBuild)
    const numLevels = useSelector(selectNumLevels)
    const numRooms = useSelector(selectNumRooms)
    const square = useSelector(selectSquare)
    const yearBuild = useSelector(selectYearBuild)
    const insuranceCompanyProperty = useSelector(selectInsuranceCompanyProperty)
    const insuranceCompanyLife = useSelector(selectInsuranceCompanyLife)

    const regAdr = useSelector(selectRegAdr)

    // const klAdrHolderReg = useSelector(selectKlAdrHolderReg)
    // const klAdrObj = useSelector(selectKlAdrObj)
    // const level = useSelector(selectLevel)

    const handleChangeAddresObject = (e) => {
        console.log(e.value)
        dispath(setAddresObject(e.value))
    }

    const handleChangeSquare = (e) => {
        dispath(setSquare(e.target.value))
    }

    const handleChangeYearBuild = (e) => {
        dispath(setYearBuild(e.target.value))
    }

    const handleChangeOne = () => {
        setCheckOne(!checkOne)
        console.log(checkOne)
    }

    const handleChangeTwo = () => {
        setCheckTwo(!checkTwo)
        console.log(checkTwo)
    }

    const handleChangeThree = () => {
        setCheckThree(!checkThree)
        console.log(checkThree)
    }

    const handleChangeFour = () => {
        setCheckFour(!checkFour)
        console.log(checkFour)
    }

    const handleCheckSameAddr = () => {
        if (!checkSameAddr) {
            dispath(setAddresObject(regAdr))
        }
        else setAddresObject('')
        setCheckSameAddr(!checkSameAddr)
    }

    const checkIns = () => {
        if (insuranceCompanyLife == "zetta" || insuranceCompanyProperty == "zetta") {
            if (yearBuild < 1982) {
                return 1
            }
        } else if (insuranceCompanyLife == "absolute" || insuranceCompanyProperty == "absolute") {
            if (yearBuild < 1960) {
                return 2
            }
        } else if (insuranceCompanyLife == "pari" || insuranceCompanyProperty == "pari") {
            if (yearBuild < 1960) {
                return 3
            }
        }
    }

    // const checkFloor = () => {
    //     if (insuranceCompanyLife == "zetta" || insuranceCompanyProperty == "zetta") {
    //         if (numLevels < 4) {
    //             return 1
    //         }
    //     } else if (insuranceCompanyLife == "absolute" || insuranceCompanyProperty == "absolute") {
    //         if (numLevels < 4) {
    //             return 2
    //         }
    //     } else {
    //         console.log(level)
    //         return 0
    //     }
    // }

    const handleFind = () => {
        if (addresObject.toString().replaceAll(' ', '') === "") {
            setIsEmptyAddress(true)
            return
        }
        else setIsEmptyAddress(false)
        setWhait(true)
        
        setShowAllFields(true)
        setTimeout(()=>{
            setWhait(false)
        }, 5000)
    }

    function checkFields() {
        console.log('checkFields', square, numLevels, numRooms, addresObject)
        const square_valid = square.toString().replaceAll(' ', '') !== ""
        const num_levels_valid = numLevels.toString().replaceAll(' ', '') !== ""
        const num_rooms_valid = numRooms.toString().replaceAll(' ', '') !== ""
        const address_valid = addresObject.toString().replaceAll(' ', '') !== ""
        const year_build_valid = yearBuild.toString().replaceAll(' ', '') !== ""

        setisEmptySquare(!square_valid)
        setisEmptyNumLevels(!num_levels_valid)
        setisEmptyNumRooms(!num_rooms_valid)
        setIsEmptyAddress(!address_valid)
        setIsEmptyYearBuild(!year_build_valid)

        return square_valid && num_levels_valid && num_rooms_valid && address_valid && year_build_valid
    }

    useEffect(() => {
        if (addresObject) {
            setShowAllFields(true)
        }
    }, []);

    return (
        <>
            <div class="section-calculator-tab-body calculator-tab-body-3">
                <div class="calculator-tab-body-blok calculator-tab-body-blok-1">
                    <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-301">Данные по
                        залоговой квартире</p>
                    <div class="tab-body-blok-info tab-body-blok-info-301">
                        <div class="tab-body-blok-info-row tab-body-blok-info-row-6">
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-21">
                                <div class="tab-body-blok-info-element-vnutr">
                                    <label class="section-two-banks-text-2" for="pet-select">Тип
                                        недвижимости</label>
                                    <input class="pole pole-step-2" name="tip" type="text" value=""
                                        placeholder="Квартира" />
                                </div>
                            </div>
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-22">
                                <div class={"tab-body-blok-info-element-vnutr" + (isEmptyAddress ? " redBorder" : "")}>
                                    <label class="section-two-banks-text-2" for="pet-select">Адрес объекта
                                        недвижимости</label>
                                    {!checkSameAddr ?
                                        <AddressSuggestions
                                            inputProps={{
                                                className: "pole pole-step-2 w_100"
                                            }}
                                            defaultQuery={addresObject}
                                            token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                            value={addresObject}
                                            onChange={handleChangeAddresObject}
                                        /> :
                                        <div className="pole pole-step-2">{addresObject}</div>
                                    }

                                </div>
                            </div>
                            <a class="button button-1 button-novostroiki-1 button-step-2 button-step-302"
                                href="#!" onClick={handleFind}>Найти</a>
                        </div>
                        <div class="tab-body-blok-info-row tab-body-blok-info-row-7 tab-body-blok-info-row-307">
                            <div class="checkbox-box checkbox-box-301">
                                <input class="checkbox-1" type="checkbox" id="zakon" name="zakon" value=""
                                    checked={checkSameAddr} onChange={handleCheckSameAddr} />
                                <label for="scales">Адрес совпадает с адресом регистрации объекта</label>
                            </div>

                        </div>
                    </div>
                    {showAllFields &&
                        <div class="tab-body-blok-info tab-body-blok-info-303" id="tab-body-blok-info-303">

                            {whait &&
                                <>
                                    <div id="tab-body-blok-info-303-vnutr">
                                        <div class="tab-body-blok-info-animation" id="tab-body-blok-info-animation-1">
                                            <p class="tab-body-blok-info-animation-text"
                                                id="tab-body-blok-info-animation-text">Ищем информацию об объекте
                                                недвижимости</p>
                                            <div class="blok-info-animation">
                                                <div class="circle-box" id="circle-box">
                                                    <div class="circle circle-1 slideInDown wow"></div>
                                                    <div class="circle circle-2 slideInDown wow"></div>
                                                    <div class="circle circle-3 slideInDown wow"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {!whait &&
                                <>
                                    <div id="tab-body-blok-info-303-vnutr">




                                        <div class="tab-body-blok-info-animation tab-body-blok-info-animation-2"
                                            id="tab-body-blok-info-animation-2">
                                            <div
                                                class="tab-body-blok-info-animation-col tab-body-blok-info-animation-col-1">
                                                <p class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2"
                                                    id="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2">
                                                    К сожалению, нам не удалось найти
                                                    данных об объекте, вы можете указать их
                                                    самостоятельно.</p>
                                            </div>
                                            <div class="tab-body-blok-info-animation-col">
                                                <p class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-3"
                                                    id="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2">
                                                    Дополнительную информацию вы можете найти на сайтах:</p>
                                                <p
                                                    class="tab-body-blok-info-animation-link tab-body-blok-info-animation-link-2">
                                                    ГИС “ЖКХ”</p>
                                                <p
                                                    class="tab-body-blok-info-animation-link tab-body-blok-info-animation-link-2 tab-body-blok-info-animation-link-3">
                                                    Информационный портал Росеестра</p>
                                            </div>

                                        </div>

                                        {false &&
                                            <>
                                                <p class="tab-body-blok-info-animation-link tab-body-blok-info-animation-link-1"
                                                    id="tab-body-blok-info-animation-link-1"
                                                    data-da=".tab-body-blok-info-animation-col,599,2">
                                                    Указать вручную</p>
                                                <p class="tab-body-blok-info-animation-link tab-body-blok-info-animation-link-2"
                                                    id="tab-body-blok-info-animation-link-2">
                                                    Указать вручную</p>
                                            </>}
                                    </div>


                                    <div class="tab-body-blok-info tab-body-blok-info-5">
                                        <div class="tab-body-blok-info-row tab-body-blok-info-row-303">
                                            <div class="tab-body-blok-info-element tab-body-blok-info-element-303">
                                                <div class={"tab-body-blok-info-element-vnutr" + (isEmptySquare ? " redBorder" : "")}>
                                                    <label class="section-two-banks-text-2" for="pet-select">Общая
                                                        площадь</label>
                                                    <input class="pole pole-step-2 mask-ploshad "
                                                        name="ploshad" type="text" value={square} onChange={handleChangeSquare} placeholder="-" />
                                                </div>
                                            </div>
                                            <div class="tab-body-blok-info-element tab-body-blok-info-element-302">
                                                <div class="form-1-col form-1-col-1">
                                                    <div class={"tab-body-blok-info-element-vnutr" + (isEmptyYearBuild ? " redBorder" : "")}>
                                                        <label class="section-two-banks-text-2" for="pet-select">
                                                            Год постройки
                                                        </label>
                                                        <InputMask mask="9999"
                                                            placeholder="ГГГГ"
                                                            className="pole pole-step-2 mask-god "
                                                            name="god_postroiki"
                                                            value={yearBuild}
                                                            onChange={handleChangeYearBuild} />
                                                    </div>
                                                </div>
                                                {checkIns() === 1 && yearBuild &&
                                                    <p id="validacia-text-2"
                                                        className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                                        Для заключения договора страхования в отношении объекта построенного
                                                        до 1982 года необходимо обратиться к менеджеру</p>
                                                }
                                                {checkIns() >= 2 && yearBuild &&
                                                    <p
                                                        id="validacia-text-2"
                                                        className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text"
                                                    >
                                                        Для заключения договора страхования в отношении объекта построенного
                                                        до 1960 года необходимо обратиться к менеджеру
                                                    </p>
                                                }
                                            </div>
                                            <div class="tab-body-blok-info-element tab-body-blok-info-element-303">
                                                <div class={"form-1-col form-1-col-1" + (isEmptyNumLevels ? " redBorder" : "")}>
                                                    <div class="tab-body-blok-info-element-vnutr">
                                                        <UniversalDropDown listOf={listNumLevels}
                                                            setFunc={setNumLevels}
                                                            selectFunc={selectNumLevels}
                                                            title="Этажность дома" />
                                                    </div>
                                                </div>
                                                {numLevels < 4 &&
                                                    <p id="validacia-text-2"
                                                        class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                                        Для заключения договора страхования в отношении объекта менее 4
                                                        этажей необходимо обратиться к менеджеру</p>
                                                }
                                            </div>
                                            <div class="tab-body-blok-info-element tab-body-blok-info-element-304">
                                                <div class="form-1-col form-1-col-1">
                                                    <div class="tab-body-blok-info-element-vnutr">
                                                        <UniversalDropDown listOf={listNumLevels}
                                                            setFunc={setLevel}
                                                            selectFunc={selectLevel}
                                                            title="Этаж квартиры" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-body-blok-info-row tab-body-blok-info-row-304">
                                            <div class="tab-body-blok-info-element tab-body-blok-info-element-305">
                                                <div class="form-1-col form-1-col-1">
                                                    <div class="tab-body-blok-info-element-vnutr">
                                                        <UniversalDropDown listOf={listMaterialBuild}
                                                            setFunc={setMaterialBuild}
                                                            selectFunc={selectMaterialBuild}
                                                            title="Материал постройки" />
                                                    </div>
                                                </div>
                                                {materialBuild === "Горючий" &&
                                                    <p id="validacia-text-2"
                                                        className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                                        Для заключения договора страхования в отношении объекта необходимо
                                                        обратиться к менеджеру</p>
                                                }
                                            </div>
                                            <div class="tab-body-blok-info-element tab-body-blok-info-element-306">
                                                <div class="form-1-col form-1-col-1">
                                                    <div class="tab-body-blok-info-element-vnutr">
                                                        <UniversalDropDown listOf={listFire}
                                                            setFunc={setFire}
                                                            selectFunc={selectFire}
                                                            title="Источник огня" />
                                                    </div>
                                                </div>
                                                {fire === 'Да' &&
                                                    <p id="validacia-text-2"
                                                        className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                                        Для заключения договора страхования в отношении объекта необходимо
                                                        обратиться к менеджеру</p>
                                                }
                                            </div>
                                            <div class="tab-body-blok-info-element tab-body-blok-info-element-307">
                                                <div class={"form-1-col form-1-col-1" + (isEmptyNumLevels ? " redBorder" : "")}>
                                                    <div class="tab-body-blok-info-element-vnutr">
                                                        <UniversalDropDown listOf={listNumRooms}
                                                            setFunc={setNumRooms}
                                                            selectFunc={selectNumRooms}
                                                            title="Количество комнат" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-body-blok-info-row tab-body-blok-info-row-305">
                                        <div class="checkbox-box checkbox-box-zalog checkbox-box-zalog-1">
                                            <input class="checkbox-1" type="checkbox" id="obekt-1" name="obekt-1"
                                                checked={checkOne} onChange={() => handleChangeOne()} />
                                            <label for="scales">Подтверждаю, что в объекте страхования недвижимого
                                                имущества
                                                нет неузаконенных перепланировок</label>
                                        </div>
                                        <div class="checkbox-box checkbox-box-zalog checkbox-box-zalog-2">
                                            <input class="checkbox-1" type="checkbox" id="obekt-2" name="obekt-2"
                                                checked={checkTwo} onChange={() => handleChangeTwo()} />
                                            <label for="scales">Дом не признан аварийным, подлежащим отселению, не
                                                находится в зоне стихийного бедствия.</label>
                                        </div>
                                        <div class="checkbox-box checkbox-box-zalog checkbox-box-zalog-3">
                                            <input class="checkbox-1" type="checkbox" id="obekt-3" name="obekt-3"
                                                checked={checkThree} onChange={() => handleChangeThree()} />
                                            <label for="scales">Подтверждаю, что все положения и оговорки настоящего
                                                заявления-декларации мне понятны, их содержание и смысл мне ясны и я
                                                согласен с ними. Состояние моего здоровья на момент заключения договора
                                                страхования соответствует требованиям настоящего
                                                заявления-декларации</label>
                                        </div>

                                        <div class="checkbox-box checkbox-box-zalog checkbox-box-zalog-4">
                                            <input class="checkbox-1" type="checkbox" id="obekt-4" name="obekt-4"
                                                checked={checkFour} onChange={() => handleChangeFour()} />
                                            <label for="scales">Подтверждаю полноту и достоверность предоставленных
                                                данных в договоре страхования</label>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    }
                    <NextBtn
                        text={'Далее'}
                        checkConfirm={checkOne && checkTwo && checkThree && checkFour}
                        setShowAlertForUser={setShowAlertForUser}
                        check={checkIns() >= 2 || fire === 'Да' || isNumLevelManager || checkIns() === 1 || materialBuild === "Горючий"}
                        checkFields={checkFields}
                        handleFind={handleFind}
                        showAllFields={showAllFields}
                    />
                    {showAlertForUser &&
                        <div class="validacia-3">
                            <p id="validacia-text"
                                class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                Поставьте все галочки
                            </p>
                        </div>
                    }
                    {(isEmptyAddress || isEmptyNumLevels) &&
                        <div class="validacia-3">
                            <p id="validacia-text"
                                class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                Не все поля заполнены
                            </p>
                        </div>
                    }
                </div>
            </div>
        </>
    );
}



